export function buildAffiliateHomeShareLink(params: { origin?: string; code: string }): string {
  const code = (params.code || '').trim()
  const origin = (params.origin || '').trim()
  const qs = new URLSearchParams()
  if (code) qs.set('ref', code)
  const q = qs.toString()
  const path = q ? `/?${q}` : '/'
  return origin ? `${origin}${path}` : path
}

export function buildAffiliateSignupFreemiumShareLink(params: { origin?: string; code: string }): string {
  const code = (params.code || '').trim()
  const origin = (params.origin || '').trim()
  const qs = new URLSearchParams()
  if (code) qs.set('ref', code)
  qs.set('plan', 'trial_7d')
  qs.set('interval', 'month')
  const path = `/cadastro?${qs.toString()}`
  return origin ? `${origin}${path}` : path
}
